import type { LoyaltyPurchasePointsOrderCreationItem } from 'api/order'
import getLoyaltyPurchasePointsItems from 'checkout/selectors/view/items/getLoyaltyPurchasePointsItems'
import { ITEM_TYPE_LOYALTY_POINTS } from 'constants/cart'
import { createSelector } from 'reselect'

const getFormattedLoyaltyPurchasePointsItems = createSelector(
  (state: App.State) => getLoyaltyPurchasePointsItems(state),
  (items: Array<App.Checkout.LoyaltyPurchasePointsItem>): Array<LoyaltyPurchasePointsOrderCreationItem> => {
    return items.map((item): LoyaltyPurchasePointsOrderCreationItem => ({
      type: ITEM_TYPE_LOYALTY_POINTS,
      transaction_key: item.transactionKey,
      offerId: item.offerId,
      total: item.total,
      basePrice: item.basePrice,
      basePoints: item.points,
      bonusPoints: item.bonusPoints,
    }))
  },
)

export default getFormattedLoyaltyPurchasePointsItems
